export default {
  PAGENOTFOUND: "पेज नहीं मिला.",
};
